export const getAllPreconfigProductCustomerPhotosReviews = ({
  preConfiguredProducts,
}) => {
  if (!preConfiguredProducts || !preConfiguredProducts.length) return [];

  let photosList = [];
  let reviewsList = [];
  let totalAverageRatings = 0;
  preConfiguredProducts.forEach(preConfigProduct => {
    photosList = photosList.concat(preConfigProduct.customer_photos_min.photos);
    reviewsList = reviewsList.concat(preConfigProduct.customer_reviews.reviews);
    totalAverageRatings += parseFloat(
      preConfigProduct.customer_reviews.averageRating
    );
  });
  const finalAverage = totalAverageRatings / preConfiguredProducts.length;
  return {
    customerPhotosList: photosList,
    customerReviewsList: reviewsList,
    averageRating: finalAverage.toFixed(1),
  };
};
